import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sparkles, Moon, Sun, Menu, X } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export default function Navigation() {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = (
    <div className={`${isMenuOpen ? 'flex flex-col space-y-4' : 'hidden'} md:flex md:flex-row md:items-center md:space-x-4 md:space-y-0`}>
      <Link
        to="/blog"
        className={`text-gray-700 dark:text-gray-100 hover:text-purple-600 dark:hover:text-purple-400 ${
          location.pathname === '/blog' ? 'border-b-2 border-purple-500' : ''
        }`}
      >
        Blog
      </Link>
      <Link
        to="/faq"
        className={`text-gray-700 dark:text-gray-100 hover:text-purple-600 dark:hover:text-purple-400 ${
          location.pathname === '/faq' ? 'border-b-2 border-purple-500' : ''
        }`}
      >
        FAQ
      </Link>
      <button
        onClick={toggleTheme}
        className="p-2 text-gray-700 dark:text-gray-100 hover:text-purple-600 dark:hover:text-purple-400"
        aria-label="Toggle dark mode"
      >
        {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </button>
    </div>
  );

  return (
    <nav className="bg-white dark:bg-dark-secondary shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <Sparkles className="h-8 w-8 text-purple-600 dark:text-purple-400" />
              <span className="ml-2 text-xl font-bold text-gray-900 dark:text-white">Reiki Near Me</span>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            {navLinks}
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 text-gray-700 dark:text-gray-100 hover:text-purple-600 dark:hover:text-purple-400"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className={`${isMenuOpen ? 'block' : 'hidden'} md:hidden`}>
        <div className="px-2 pt-2 pb-3 space-y-1">
          {navLinks}
        </div>
      </div>
    </nav>
  );
} 